export const knowServiceResidencial = [
    {
        "header": "CONOCE NUESTROS",
        "title": "SERVICIOS PARA EDIFICIOS",
        "subtitle": "RESIDENCIALES",
        "description": "Contamos con servicios Residenciales de mantenimiento como la Restauración, Limpieza en Alturas, Pintura, Acabados e Instalaciones para su inmueble.",
        "button": "PROYECTOS",
        "buttonLink": "/proyectos",
        "specializedHeader": "SOMOS",
        "specializedTitle": "PROFECIONALES",
        "specializedSubtitle": "Y CERTIFICADOS",
        "image": "/assets/imgs/services/residenciales/trabajador.jpg",
        "backgroundColor": "#EA0029"
    }
];

export const knowServiceResidencialEn = [
    {
        header: "DISCOVER OUR",
        title: "SERVICES FOR",
        subtitle: "RESIDENTIAL BUILDINGS",
        description:
            "We provide residential maintenance services such as restoration, high-altitude cleaning, painting, finishes, and installations for your property.",
        button: "PROJECTS",
        buttonLink: "/projects",
        specializedHeader: "WE ARE",
        specializedTitle: "PROFESSIONAL",
        specializedSubtitle: "AND CERTIFIED",
        image: "/assets/imgs/services/residenciales/trabajador.jpg",
        backgroundColor: "#EA0029"
    }
];

